/**
 * Function for loading JS library
 * @param id {String} id for the newly creating script element
 * @param location {String} path for the library
 */
export const loadJs = (id, location, type = "application/javascript", integrity = "", crossOrigin = "") => {
  return new Promise(async (resolve, reject) => {
    try {
      if (document.getElementById(id)) {
        let element = document.getElementById(id)

        element.onload = () => resolve()

        element.onerror = () => reject(`Error loading ${id} library`)

        // console.log(window[id] != undefined, window[id] instanceof HTMLElement != true, window[id], "check")

        if (window[id] != undefined && window[id] instanceof HTMLElement != true) resolve()
      } else {
        let elem = document.createElement("script")
        elem.id = id
        elem.type = type
        elem.src = location
        if (crossOrigin) elem.crossOrigin = crossOrigin
        if (integrity) elem.integrity = integrity

        elem.onload = () => resolve()
        elem.onerror = () => reject(`Error loading ${id} JS library`)

        document.body.appendChild(elem)
      }
    } catch (error) {
      reject(error)
    }
  })
}
/**
 * Function for loading CSS library
 * @param id {String} id for the newly creating script element
 * @param location {String} path for the library
 */
export const loadCSS = async (id, location) => {
  return new Promise((resolve, reject) => {
    try {
      if (document.getElementById(id)) {
        resolve()
      } else {
        let elem = document.createElement("link")
        elem.id = id
        elem.href = location
        elem.rel = "stylesheet"
        document.body.appendChild(elem)
        elem.onload = () => resolve()
        elem.onerror = () => reject(`Error loading ${id} CSS`)
      }
    } catch (error) {
      reject(error)
    }
  })
}
